import React, { Component } from "react";

class ExclamationSVG extends React.Component {
  render() {
    return (
      <svg
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        viewBox="0 0 12 12"
      >
        <path
          className="svg"
          d="M5.2,0h1.7v8.9H5.2V0z M5.2,10.3h1.7V12H5.2V10.3z"
        />
      </svg>
    );
  }
}

export default ExclamationSVG;



// WEBPACK FOOTER //
// ./src/svg/ExclamationSVG.jsx